import { Link } from "react-router-dom";

// Footer. Intentionally minimal — no Contact column, no phone number,
// no filler nav links. Only what's required legally or to route users
// to a page that exists today.
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="v3-container">
      <div className="v3-foot">
        <h3 className="v3-foot-brand">
          Dash<span style={{ color: "var(--mist-4)" }}>—</span>
        </h3>
        <div className="v3-foot-col">
          <span className="l">Product</span>
          <Link to="/pricing">Pricing</Link>
        </div>
        <div className="v3-foot-col">
          <span className="l">Legal</span>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </div>
        <div className="v3-foot-col">
          <span className="l">Status</span>
          <span
            style={{
              fontFamily: "var(--font-mono)",
              fontSize: 11,
              color: "var(--ink-2)",
              letterSpacing: "var(--track-wide)",
            }}
          >
            In early access.
            <br />
            Reach out via the demo.
          </span>
        </div>
      </div>
      <div className="v3-foot-tail">
        <span>© Dash · {year}</span>
      </div>
    </footer>
  );
}
